/** @jsxImportSource @emotion/react */
import { Box, Paper, Stack, Typography } from "@mui/material"
import React, { FC, ReactNode, useContext, useMemo } from "react"
import { ChainIds } from "types"
import ConnectButton from "components/Layout/ConnectButton"

import { SwitchToActiveNetworkButton } from "./EnableToken"
import { AuthContext } from "context/AuthContext"

interface ConnectFirstProps {
  children: ReactNode
  buttons?: ReactNode[]
  title: string
  isKYCNotVerified?: boolean
}

const ConnectFirst: FC<ConnectFirstProps> = ({ isKYCNotVerified, buttons, children, title }) => {
  const { address, chain } = useContext(AuthContext)

  const wrongNetwork = useMemo(() => !!chain?.id && ![ChainIds.MAINNET, ChainIds.BSC].includes(chain?.id), [chain?.id])
  const connectFirst = wrongNetwork || !address || isKYCNotVerified

  return connectFirst ? (
    <Paper
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        zIndex: 5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography textAlign="center" variant="h6" mb={2}>
        {wrongNetwork ? "Switch to a supported network to view your positions" : title}
      </Typography>
      <Stack direction="row" spacing={2}>
        {wrongNetwork ? <SwitchToActiveNetworkButton /> : buttons || <ConnectButton />}
      </Stack>
    </Paper>
  ) : (
    <>{children}</>
  )
}

export default ConnectFirst
